import { render, staticRenderFns } from "./customLogin.vue?vue&type=template&id=b4c726c8&scoped=true&"
import script from "./customLogin.vue?vue&type=script&lang=js&"
export * from "./customLogin.vue?vue&type=script&lang=js&"
import style0 from "./customLogin.vue?vue&type=style&index=0&id=b4c726c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c726c8",
  null
  
)

export default component.exports